"use client";

import React from 'react';
import { useMediaQuery } from "react-responsive";
import { useTranslation } from 'react-i18next';
import AboutSectionTwoDesktop from './Desktop/AboutSectionTwoDesktop';
import AboutSectionTwoMobile from './Mobile/AboutSectionTwoMobile';

const AboutSectionTwo = () => {
  const { t } = useTranslation('translation');
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const title1 = t("aboutSectionTwoTitle1");
  const description1 = t("aboutSectionTwoDescription1");
  const title2 = t("aboutSectionTwoTitle2");
  const description2 = t("aboutSectionTwoDescription2");
  const title3 = t("aboutSectionTwoTitle3");
  const description3 = t("aboutSectionTwoDescription3");

  return (
    <section className="py-16 md:py-20 lg:py-28">
      {isMobile ? (
        <AboutSectionTwoMobile
          title1={title1}
          description1={description1}
          title2={title2}
          description2={description2}
          title3={title3}
          description3={description3}
        />
      ) : (
        <AboutSectionTwoDesktop
          title1={title1}
          description1={description1}
          title2={title2}
          description2={description2}
          title3={title3}
          description3={description3}
        />
      )}
    </section>
  );
};

export default AboutSectionTwo;